/**
 * NDK Lazy Section Loader v1.0
 * Carga diferida de secciones below-the-fold usando Intersection Observer.
 *
 * Uso en secciones Liquid:
 *   Añadir atributo  data-ndk-lazy  al wrapper raíz de la sección.
 *   Opcionalmente  data-ndk-lazy-threshold="0.1"  (default 0.05)
 *
 * Comportamiento:
 *   - La sección empieza con opacity:0 / visibility:hidden.
 *   - Cuando entra en viewport (threshold configurable) se añade la clase
 *     .ndk-section-visible  que dispara la transición de entrada.
 *   - Si el navegador no soporta IntersectionObserver, todo es visible por defecto.
 *
 * Integración con Swiper:
 *   Si la sección contiene  [data-ndk-lazy-swiper]  se inicializa Swiper SÓLO
 *   cuando la sección es visible, evitando cálculos de layout innecesarios.
 */

(function () {
  'use strict';

  // ── Estilos base ──────────────────────────────────────────────────────────
  var style = document.createElement('style');
  style.textContent = [
    '[data-ndk-lazy]{',
    '  opacity:0;',
    '  transform:translateY(20px);',
    '  transition:opacity .5s ease,transform .5s ease;',
    '  will-change:opacity,transform;',
    '}',
    '[data-ndk-lazy].ndk-section-visible{',
    '  opacity:1;',
    '  transform:none;',
    '}',
    /* Reduce motion: skip animation but still show */
    '@media(prefers-reduced-motion:reduce){',
    '  [data-ndk-lazy]{transition:none;opacity:0;}',
    '  [data-ndk-lazy].ndk-section-visible{opacity:1;}',
    '}'
  ].join('');
  document.head.appendChild(style);

  // ── Fallback sin soporte ──────────────────────────────────────────────────
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('[data-ndk-lazy]').forEach(function (el) {
      el.classList.add('ndk-section-visible');
    });
    return;
  }

  // ── Helper: inicializar Swipers declarados dentro de la sección ───────────
  function initSwiperIfNeeded(section) {
    var swiperEls = section.querySelectorAll('[data-ndk-lazy-swiper]');
    if (!swiperEls.length) return;
    if (typeof Swiper === 'undefined') return; // Swiper no cargado en este template

    swiperEls.forEach(function (el) {
      if (el._ndkSwiperInit) return; // ya inicializado
      el._ndkSwiperInit = true;

      // Leer opciones desde atributo JSON (opcional)
      var opts = {};
      try {
        if (el.dataset.ndkLazySwiperOptions) {
          opts = JSON.parse(el.dataset.ndkLazySwiperOptions);
        }
      } catch (e) {}

      new Swiper(el, opts);
    });
  }

  // ── Observer principal ────────────────────────────────────────────────────
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        var section = entry.target;
        section.classList.add('ndk-section-visible');
        initSwiperIfNeeded(section);

        observer.unobserve(section); // cada sección se anima solo una vez
      });
    },
    {
      rootMargin: '0px 0px -60px 0px', // empieza a cargar 60px antes de entrar
      threshold: 0.05
    }
  );

  // ── Observar secciones marcadas ───────────────────────────────────────────
  function observeSections() {
    document.querySelectorAll('[data-ndk-lazy]').forEach(function (el) {
      // Threshold personalizado por sección
      var customThreshold = parseFloat(el.dataset.ndkLazyThreshold);
      if (customThreshold && !isNaN(customThreshold)) {
        // Crear observer específico para este elemento con su threshold
        var specificObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('ndk-section-visible');
              initSwiperIfNeeded(entry.target);
              specificObserver.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -60px 0px', threshold: customThreshold }
        );
        specificObserver.observe(el);
      } else {
        observer.observe(el);
      }
    });
  }

  // Ejecutar tras DOMContentLoaded o inmediatamente si el DOM ya está listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeSections);
  } else {
    observeSections();
  }

})();
